import React from 'react';
import PropTypes from 'prop-types';
import $t from 'lib/trackingService';
import { isLengthGreaterThan8, getFontSizeFromCharLength } from 'lib/fontBasedOnTextLength';
import classNames from 'classnames';
import styles from './styles.module.scss';

const vendorToolkit = ['df', 'bw-1px', 'items-center'];
const shopIconToolkit = ['lh-copy', 'f2', 'white'];

function ShopButton({
  additionalStyles,
  block,
  fontToolkit,
  isWaffle,
  isBacon,
  listPrice,
  name,
  seller,
}) {
  const sellerFontSize = getFontSizeFromCharLength(seller);
  const bemElemVendorBtn = `${block}__vendorBtn`;
  const isLongerThan8Chars = isLengthGreaterThan8(seller);
  return (
    <div className={classNames(styles.shop, additionalStyles.shop)}>
      <button
        type="button"
        className={classNames(bemElemVendorBtn, styles.vendor, additionalStyles.vendor, 'w-100', {
          [`${styles.vendorFitText} pl3-m`]: isLongerThan8Chars && isWaffle,
          [`${styles.vendorFitText}`]: isLongerThan8Chars,
          [`${styles.baconButton} pl3`]: isBacon,
          pl5: !isBacon,
        }, vendorToolkit)}
        onClick={() => {
          $t('track', 'mbt_ecommerce_shop_button', {
            name,
            listPrice,
            seller,
          });
        }}
      >
        <span className={classNames(styles.icon, additionalStyles.icon, shopIconToolkit, 'icon icon-shop')} />
        <span className={classNames(styles.vendorName, additionalStyles.vendorName, fontToolkit, sellerFontSize, 'ttu', 'white', 'tl')}>
          {seller}
        </span>
      </button>
    </div>
  );
}

ShopButton.propTypes = {
  additionalStyles: PropTypes.shape().isRequired,
  block: PropTypes.string.isRequired,
  fontToolkit: PropTypes.string,
  isWaffle: PropTypes.bool.isRequired,
  isBacon: PropTypes.bool,
  listPrice: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  seller: PropTypes.string.isRequired,
};

ShopButton.defaultProps = {
  fontToolkit: '',
  isBacon: false,
};

export default ShopButton;
